import { useIsMobile } from '@/hooks/useIsMobile';
import ArticleCardSkeleton from './ArticleCardSkeleton';

function HeroArticlesSkeleton() {
  const isMobile = useIsMobile();

  return isMobile ? (
    <div aria-label='articles loading...' className='flex flex-col gap-3'>
      <ArticleCardSkeleton imagePosition='top' />
      <ArticleCardSkeleton layout='noImageMobile' />
      <ArticleCardSkeleton layout='noImageMobile' />
    </div>
  ) : (
    <div aria-label='articles loading...' className='mx-auto'>
      <div className='grid md:grid-cols-[4fr_5fr] md:grid-rows-[repeat(2,minmax(200px,1fr))] md:gap-6'>
        <ArticleCardSkeleton imagePosition='top' layout='halfImage' className='row-span-full' />
        <ArticleCardSkeleton />
        <ArticleCardSkeleton />
      </div>
    </div>
  );
}

export default HeroArticlesSkeleton;
